// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../../css-global/colors.scss\"","_blue":"#1478a6","root":"DownloadCsvLink-module--root--2RXOr"};